import React from 'react';
import { connect } from 'react-redux';
import { stableSort } from '../../utils/comparators';
import { percent } from '../../utils/parsing';
import { scoreSort } from '../ingestQa/PointTypeSelector';
import Selector from '../util/Selector';

const EquipTypeSelector = ({
  equipTypes,
  selected,
  onChange,
  disabled,
  showNullOption,
  filter = () => true,
}) => (
  <Selector
    options={equipTypes.filter(filter).map(({ id, nameLong, score }) => ({
      id,
      key: `${id}`,
      display: score ? `${nameLong} (${percent(score)})` : nameLong,
    }))}
    selected={selected ? `${selected}` : ''}
    onChange={({ target: { value } }) => onChange(value)}
    disabled={disabled}
    showNullOption={showNullOption}
  />
);

export default connect(
  (
    {
      entities: {
        equipTypes: { alphabeticalIds, byId, idByName },
      },
    },
    { predictions }
  ) => {
    const predictionsById = Object.entries(predictions ?? {}).reduce((o, [name, score]) => {
      const id = idByName[name];
      if (id) {
        // eslint-disable-next-line no-param-reassign
        o[id] = score;
      }
      return o;
    }, {});
    const equipTypes = alphabeticalIds
      .map((id) => byId[id])
      .map((et) => ({
        ...et,
        score: predictionsById[et.id],
      }));
    const sorted = stableSort(equipTypes, scoreSort);
    return { equipTypes: sorted };
  }
)(EquipTypeSelector);
